class Url {
  constructor(environment = 'live') {

    switch(environment) {
      case 'dev':
        this.api = "https://dev.api.ai-pro.org";
        this.start = "https://dev.start.ai-pro.org";
        this.wp = "https://dev.ai-pro.org";
        break;
      case 'stag':
        this.api = "https://staging.api.ai-pro.org";
        this.start = "https://staging.start.ai-pro.org";
        this.wp = "https://staging.ai-pro.org";
        break;
      case 'live':
      default:
        this.api = "https://api.ai-pro.org";
        this.start = "https://start.ai-pro.org";
        this.wp = "https://ai-pro.org";
        break;
    }
    this.domain = ".ai-pro.org";
    this.register = this.start + "/register";
    this.upgrade = this.start + "/upgrade";
    this.splash = this.start + "/splash";
    this.authFailed = this.start + "/redirect-account-required";
    this.apiGetUsage = this.api + "/e/get-usage/";
    this.apiSetUsage = this.api + "/e/set-usage/";
    this.flowUrls = {
      imagegen: this.wp + '/landing-imagegen/pricing',
      image: this.wp + '/landing-image/pricing',
      aiart: this.wp + '/landing-aiart/pricing'
    };

  }

}

module.exports = Url;